
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.865.274h-14.7c-.836 0-1.637.296-2.228.824-.59.527-.922 1.243-.922 1.989v9.374c0 .746.332 1.462.922 1.99.591.527 1.392.823 2.228.823h14.7c.835 0 1.636-.296 2.227-.824.59-.527.923-1.242.923-1.989V3.087c0-.746-.332-1.462-.923-1.99C19.502.57 18.7.275 17.865.275zm-.43 1.875L11.26 7.662a1.066 1.066 0 01-.341.205 1.16 1.16 0 01-.808 0 1.065 1.065 0 01-.342-.205L3.595 2.149h13.84zm1.48 10.312a.89.89 0 01-.308.663 1.117 1.117 0 01-.742.275h-14.7c-.279 0-.546-.099-.743-.274a.89.89 0 01-.307-.664v-8.99l6.174 5.512c.59.527 1.391.823 2.226.823s1.635-.296 2.226-.823l6.174-5.512v8.99z"}})])
          )
        }
      }
    